import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../environment';

@Injectable({ providedIn: 'root' })
export class FeatureService {
  private http = inject(HttpClient);
  private env = inject(environment);
  private featureUrl = this.env.featureUrl;

  private features = new BehaviorSubject<Feature[]>(undefined);

  public fetchFeatures(): Observable<Feature[]> {
    return this.http
      .get<Feature[]>(this.featureUrl)
      .pipe(tap((features) => this.features.next(features)));
  }

  public getFeatureActive(name: string) {
    const features = this.features.value;
    if (!features) {
      return false;
    }

    const flag = features.find((f) => f.name === name);
    if (!flag) {
      return false;
    }

    return flag.active;
  }
}

export function initializeFeatures(featureService: FeatureService) {
  return () => featureService.fetchFeatures();
}

export interface Feature {
  name: string;
  active: boolean;
}
